import comp from "./OrganizationCard";
export default comp;
